<div class=".d-align-center f-row profile-navigation">
    <app-edit-flight-search></app-edit-flight-search>
    <app-login-profile></app-login-profile>
</div>